import { render, staticRenderFns } from "./bol.vue?vue&type=template&id=ec2ae6ac&scoped=true&"
import script from "./bol.vue?vue&type=script&lang=js&"
export * from "./bol.vue?vue&type=script&lang=js&"
import style0 from "./bol.vue?vue&type=style&index=0&id=ec2ae6ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2ae6ac",
  null
  
)

export default component.exports